export default __webpack_public_path__ + "static/media/5.ed8a5116.svg";